<div class="tab-list">
  <app-tab-list>
    <app-tab
      url="holidays"
      tabTitle="Holidays"
      *ngIf="isHolidaysandOfficesAccess"
    >
    </app-tab>
    <app-tab
      url="offices"
      tabTitle="Offices"
      *ngIf="isHolidaysandOfficesAccess"
    >
    </app-tab>
    <app-tab
      url="tech-stacks-and-positions"
      tabTitle="Tech stacks & Positions"
      *ngIf="isTechStackandPositionAccess"
    >
    </app-tab>
  </app-tab-list>
</div>
